import type { PlanOptions } from "../../api/routing";

/** Step 3, the day: the working window, the time spent at each site, a cap on
 * sites a day, the first day, how the stops are grouped, and whether the crew
 * drives home and works weekends. */
export default function DayStep({ options, onOptions }: { options: PlanOptions; onOptions: (next: PlanOptions) => void }) {
  function opt<K extends keyof PlanOptions>(key: K, value: PlanOptions[K]) {
    onOptions({ ...options, [key]: value });
  }
  return (
    <>
      <div className="step-fields">
        <label className="field">
          Day starts
          <input type="time" value={options.day_start} onChange={(e) => opt("day_start", e.target.value)} />
        </label>
        <label className="field">
          Day ends
          <input type="time" value={options.day_end} onChange={(e) => opt("day_end", e.target.value)} />
        </label>
        <label className="field">
          Minutes on site
          <input inputMode="numeric" value={options.on_site_minutes} onChange={(e) => opt("on_site_minutes", Number(e.target.value) || 0)} />
        </label>
        <label className="field">
          Max sites a day
          <input
            inputMode="numeric"
            value={options.max_per_day ?? ""}
            placeholder="No cap"
            onChange={(e) => opt("max_per_day", e.target.value === "" ? null : Number(e.target.value) || null)}
          />
        </label>
        <label className="field">
          First day
          <input type="date" value={options.first_day ?? ""} onChange={(e) => opt("first_day", e.target.value || null)} />
        </label>
        <label className="field">
          Strategy
          <select value={options.strategy} onChange={(e) => opt("strategy", e.target.value)}>
            <option value="cluster">Cluster nearby sites</option>
            <option value="greedy">Nearest next</option>
          </select>
        </label>
      </div>
      <div className="step-checks">
        <label className="check">
          <input type="checkbox" checked={options.return_home} onChange={(e) => opt("return_home", e.target.checked)} /> Return to the depot
        </label>
        <label className="check">
          <input type="checkbox" checked={options.include_weekends} onChange={(e) => opt("include_weekends", e.target.checked)} /> Include weekends
        </label>
      </div>
    </>
  );
}
